<template>
<div>
   <section class="section_logo-bar">
    <div class="logonav_wrap">
      <div class="logonav_div">
        <a href="#" class="link-block-73 w-inline-block"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-487"></a>
      </div>
    </div>
  </section>
    <div>
        <div class="form-wrapper">
            <div class="form-main-div">
                <!-- Step 1: Welcome and Terms Agreement -->
                <div class="enroll-slide-10" v-if="active_el === 1">
                    <div class="form-block-20 w-form">
                        <form @submit.prevent="handleSubmit">
                            <div class="enroll-slide-1-div-3"><img sizes="(max-width: 641px) 100vw, 641px" srcset="@/assets/images/stepsimage_teledoc_nS_1-p-500.webp 500w, @/assets/images/stepsimage_teledoc_nS_1stepsimage_teledoc_nS.webp 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS_1stepsimage_teledoc_nS.webp" loading="lazy" class="enroll-top-image">
                                <div class="enroll-header-2">Welcome to RxPros</div>
                                <p class="enroll-sub-2">The following questions will will be used by a board certified physician licensed in your state to help create a treatment plan for you. <strong>Please answer all questions accurately.</strong></p>
                                <div class="enroll-3-things-div">
                                    <div class="enroll-bullet-div-2"><img loading="lazy" src="@/assets/images/icon_ohmy_meds_1icon_ohmy_meds.webp" alt="" class="enroll-bullet-image-2">
                                        <div class="enroll-bullet-text-2">All Dosages Same Price</div>
                                    </div>
                                    <div class="enroll-bullet-div-2"><img loading="lazy" src="@/assets/images/icon_ohmy_doc.webp" alt="" class="enroll-bullet-image-2">
                                        <div class="enroll-bullet-text-2">Board-certified physicians</div>
                                    </div>
                                    <div class="enroll-bullet-div-2"><img loading="lazy" src="@/assets/images/icon_ohmy_pharma_1icon_ohmy_pharma.webp" alt="" class="enroll-bullet-image-2">
                                        <div class="enroll-bullet-text-2">503A Pharmacy Partners</div>
                                    </div>
                                </div>
                                <div class="enroll-disclaimer-div _1st">
                                    <label class="w-checkbox enroll-checkbox-field-3">
                                        <input type="checkbox" v-model="people.agreed_to_terms" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top">
                                        <span class="enroll-checkbox-label-2 w-form-label" for="checkbox-3">I Agree to RxPros&#x27; <a href="https://www.rxpros.com/terms" target="_blank" class="enroll-checkbox-link-2">Terms</a>, <a href="https://www.rxpros.com/privacy" target="_blank" class="enroll-checkbox-link-2">Privacy Policy</a> and consent to <a href="https://www.rxpros.com/telehealth" target="_blank" class="enroll-checkbox-link-2">Telehealth</a></span>
                                    </label>
                                    <div v-if="formErrors.terms" class="error-message">{{ formErrors.terms }}</div>
                                </div>
                                <div class="enroll-form-button-div"><input type="submit" data-wait="Please wait..." class="enroll-form-submit-button-2 top w-button" value="Start my FREE visit -&gt;"></div>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- Step 2: Basic Information (State, Name, Gender, Email, Phone) -->
                <div class="enroll-slide-8" v-if="active_el === 2">
                    <div class="enroll-form-header-div">
                        <div class="enroll-form-header-text-2">Let&#x27;s start with the Basics</div>
                    </div>
                    <div class="enroll-form-block update w-form">
                        <form @submit.prevent="handleSubmit" class="enroll-form update">
                            <h1 class="form-question-text smaller a">Let&#x27;s make sure we are licensed in your state</h1>
                            <select id="State-4" v-model="people.state" name="State-4" data-name="State 4" required class="select-field-16 form update w-select">
                                <option value="">State...</option>
                                <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                            </select>
                            <div v-if="formErrors.state" class="error-message">{{ formErrors.state }}</div>

                            <h1 class="form-question-text smaller a">Who do I have the pleasure of talking to?</h1>
                            <div class="enroll-form-field-wrap-div update">
                                <input class="text-field-59 update w-input" maxlength="256" v-model="people.first_name" name="name" data-name="Name" placeholder="First Name" type="text" id="name" required>
                                <input class="text-field-59 update w-input" maxlength="256" v-model="people.last_name" name="Last-name" data-name="Last Name" placeholder="Last Name" type="text" id="Last-name" required>
                            </div>
                            <div v-if="formErrors.name" class="error-message">{{ formErrors.name }}</div>

                            <h1 class="form-question-text smaller a">What was your gender at birth?</h1>
                            <div class="div-block-1893">
                                <label class="w-checkbox checkbox-field-24 male" :class="{ 'selected': people.gender === 'Male' }">
                                    <input type="checkbox" :checked="people.gender === 'Male'" @change="handleGenderSelection('Male')" name="gender-male" class="w-checkbox-input enroll-checkbox">
                                    <span class="checkbox-label-26 w-form-label">Male</span>
                                </label>
                                <label class="w-checkbox checkbox-field-24 female" :class="{ 'selected': people.gender === 'Female' }">
                                    <input type="checkbox" :checked="people.gender === 'Female'" @change="handleGenderSelection('Female')" name="gender-female" class="w-checkbox-input enroll-checkbox">
                                    <span class="checkbox-label-26 w-form-label">Female</span>
                                </label>
                            </div>
                            <div v-if="formErrors.gender" class="error-message">{{ formErrors.gender }}</div>

                            <h1 class="form-question-text smaller a">Please enter your email</h1>
                            <input class="text-field-59 email form update w-input" :class="{ 'email-error': emailCheckError }" maxlength="256" v-model="people.email" @blur="checkEmailOnBlur" name="Email-2" data-name="Email 2" placeholder="Enter your email" type="email" id="Email-2" required>
                            <div v-if="formErrors.email" class="error-message">{{ formErrors.email }}</div>

                            <h1 class="form-question-text smaller a">Please enter your mobile number</h1>
                            <div class="phone-entry-div update">
                                <input class="phone-number-field-6 _1 form update w-input"
                                    maxlength="3"
                                    v-model="people.phone_parts.areaCode"
                                    @input="handlePhoneInput($event, 'areaCode')"
                                    ref="areaCode"
                                    name="num1"
                                    placeholder="(000)"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    type="text"
                                    autocomplete="off"
                                    required>
                                <div class="text-block-1540">-</div>
                                <input class="phone-number-field-6 form update w-input"
                                    maxlength="3"
                                    v-model="people.phone_parts.prefix"
                                    @input="handlePhoneInput($event, 'prefix')"
                                    ref="prefix"
                                    name="num2"
                                    placeholder="000"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    type="text"
                                    autocomplete="off"
                                    required>
                                <div class="text-block-1540">-</div>
                                <input class="phone-number-field-6 _2 form update w-input"
                                    maxlength="4"
                                    v-model="people.phone_parts.line"
                                    @input="handlePhoneInput($event, 'line')"
                                    ref="line"
                                    name="num3"
                                    placeholder="0000"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    type="text"
                                    autocomplete="off"
                                    required>
                            </div>
                            <div v-if="formErrors.phone" class="error-message">{{ formErrors.phone }}</div>

                            <div class="enroll-disclaimer-div-2 form" :class="{ 'is-shaking': shakeConsent }" @animationend="shakeConsent = false">
                                <label class="w-checkbox enroll-checkbox-field-2 form" :class="{ 'field-error': formErrors.emailConsent }">
                                    <input type="checkbox" v-model="people.agreed_to_email" name="checkbox-sms" id="checkbox-sms" data-name="Checkbox SMS" class="w-checkbox-input enroll-checkbox">
                                    <span class="enroll-checkbox-label-3 form w-form-label" for="checkbox-sms">By checking the box, you agree that RXPros can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.rxpros.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://www.rxpros.com/terms" target="_blank">Terms</a>.</span>
                                </label>
                            </div>
                            <div v-if="formErrors.emailConsent" class="error-message">{{ formErrors.emailConsent }}</div>

                            <input type="submit" :disabled="checkingEmail" data-wait="Please wait..." class="enroll-form-submit-button-3 w-button" :value="checkingEmail ? 'Please wait...' : 'Next -&gt;'">
                        </form>
                    </div>
                    <div class="enroll-form-back-link-div-2" v-if="active_el !== 2">
                        <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text-2">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
                <!-- Step 3: Date of Birth -->
                <div class="enroll-slide-9" v-if="active_el === 3">
                    <h1 class="form-question-text">What is your date of birth?</h1>
                    <div class="enroll-form-block b w-form">
                        <form @submit.prevent="validateDOB" class="enroll-form b">
                            <div class="enroll-form-field-wrap-div b">
                                <div class="_3-input-div">
                                    <select id="field-4" v-model="people.dob.mm" name="field-4" data-name="Field 4" class="select-3rds w-select" required @change="$refs.dobDay.focus()">
                                        <option value="">Month</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                    <input class="input-3rds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" v-model="people.dob.dd" name="dob-day" data-name="DOB Day" placeholder="Day" type="text" id="dob-day" required @keypress="numericOnly" @input="autoAdvanceDobField('dd', 2, 'dobYear')" ref="dobDay">
                                    <input class="input-3rds w-input" maxlength="4" pattern="[0-9]*" inputmode="numeric" v-model="people.dob.yyyy" name="dob-year" data-name="DOB Year" placeholder="Year" type="text" id="dob-year" required @keypress="numericOnly" ref="dobYear">
                                </div>
                            </div>
                            <div v-if="formErrors.dob" class="error-message">{{ formErrors.dob }}</div>
                            <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button-3 b w-button" :value="'Next ->'">
                        </form>
                    </div>
                    <div class="enroll-form-back-link-div-2">
                        <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text-2">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
                <!-- Step 4: Height and Weight -->
                <div class="enroll-slide-9" v-if="active_el === 4">
                    <h1 class="form-question-text">What is your height and weight?</h1>
                    <p class="enroll-form-question-sub-2">We&#x27;ll use this to determine your Body mass Index (BMI) for diagnosis. remember, BMI is a measure of size - not health</p>
                    <div class="enroll-form-block b w-form">
                        <form @submit.prevent="handleSubmit" class="enroll-form b">
                            <div class="enroll-form-field-wrap-div b">
                                <div class="enroll-form-input-div mobile-entry form _2 height top">
                                    <input class="enroll-form-text-field-2 height w-input" maxlength="1" v-model="people.height.foot" name="feet" data-name="Feet" placeholder="Feet" type="text" id="feet" inputmode="numeric" pattern="[0-9]*" required @keypress="numericOnly" ref="feetInput" @input="autoAdvanceGeneric($event, 1, 'inchesInput')">
                                    <div class="field-label-text-2">ft.</div>
                                    <input class="enroll-form-text-field-2 height update w-input" maxlength="2" v-model="people.height.inches" name="inches" data-name="Inches" placeholder="Inches" type="text" id="inches" inputmode="numeric" pattern="[0-9]*" required @keypress="numericOnly" ref="inchesInput" @input="validateInches(); autoAdvanceGeneric($event, 2, 'weightInput')">
                                    <div class="field-label-text-2 last">in.</div>
                                </div>
                                <div v-if="formErrors.height" class="error-message">{{ formErrors.height }}</div>
                                <div class="enroll-form-input-div mobile-entry form _2 weight">
                                    <input class="enroll-form-text-field-2 weight w-input" maxlength="3" v-model="people.weight" name="weight-2" data-name="Weight 2" pattern="[0-9]*" inputmode="numeric" placeholder="Weight in pounds" type="text" id="weight-2" required @keypress="numericOnly" ref="weightInput">
                                    <div class="field-label-text-2 weight">lbs.</div>
                                </div>
                                <div v-if="formErrors.weight" class="error-message">{{ formErrors.weight }}</div>
                            </div>
                            <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button-3 b w-button" :value="'Next ->'">
                        </form>
                    </div>
                    <div class="enroll-form-back-link-div-2">
                        <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text-2">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
                <!-- Step 5: Desired Weight -->
                <div class="enroll-slide-9" v-if="active_el === 5">
                    <h1 class="form-question-text">What is your <strong>desired weight</strong>?</h1>
                    <div class="enroll-form-block b update w-form">
                        <form @submit.prevent="handleSubmit" class="enroll-form b">
                            <div class="enroll-form-field-wrap-div b">
                                <div class="enroll-form-input-div mobile-entry form _2 weight">
                                    <input class="enroll-form-text-field-2 weight w-input" maxlength="3" v-model="people.desired_weight" name="Goal-Weight" data-name="Goal Weight" placeholder="What is your goal weight in pounds?" pattern="[0-9]*" inputmode="numeric" type="text" id="Goal-Weight" required @keypress="numericOnly">
                                    <div class="field-label-text-2 weight">lbs.</div>
                                </div>
                                <div v-if="formErrors.desiredWeight" class="error-message">{{ formErrors.desiredWeight }}</div>
                            </div>
                            <input type="submit" :disabled="isSubmitting" data-wait="Please wait..." class="enroll-form-submit-button-3 b w-button" :value="isSubmitting ? 'Please wait...' : 'Start my FREE visit -&gt;'">
                            <div v-if="formErrors.submission" class="error-message">{{ formErrors.submission }}</div>
                        </form>
                    </div>
                    <div class="enroll-form-back-link-div-2">
                        <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text-2">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height: 420px;"></div>

    <!-- Paid User Modal -->
    <div v-if="showPaidUserModal" class="modal-overlay" @click.self="showPaidUserModal = false">
        <div class="modal-content">
            <button class="modal-close" @click="showPaidUserModal = false">&times;</button>
            <div class="modal-body">
                <h2 class="modal-title">Welcome back!</h2>
                <p v-if="modalMode === 'wrong_role'">This email is associated with a {{ modalRole }} account. Please log in to continue, or use a different email.</p>
                <p v-else>You already have an account with us. Log in to manage your treatment, track shipments, and message your care team.</p>
                <button class="modal-btn modal-btn-primary" @click="goToLogin">Log In</button>
                <!-- The free NAD+ claim shows only on a link with ?nad=nasal or ?nad=injection. -->
                <button v-if="showNadClaim" class="modal-btn modal-btn-secondary modal-btn-claim" @click="goToNadClaim">Claim My Free NAD+</button>
                <button class="modal-btn modal-btn-secondary" @click="showPaidUserModal = false">Not me — use a different email</button>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>

input.enroll-form-submit-button-3.b {
    color: #fff !important;
}

.error-message {
    color: #e53e3e;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
}

.enroll-checkbox-field-2.field-error .enroll-checkbox-label-3 {
    color: #e53e3e;
}

@keyframes consent-shake {
    0%, 100% { transform: translateX(0); }
    20% { transform: translateX(-8px); }
    40% { transform: translateX(8px); }
    60% { transform: translateX(-8px); }
    80% { transform: translateX(8px); }
}
.is-shaking {
    animation: consent-shake 0.5s ease-in-out;
}

.phone-entry-div.update {
    margin-bottom: 8px;
}

.sms-disclaimer {
    color: #6c7e8d;
    font-size: 11px;
    line-height: 15px;
    margin-top: 0;
    margin-bottom: 24px;
}
.sms-disclaimer a {
    color: #6c7e8d;
    text-decoration: underline;
}

.enroll-disclaimer-div-2.form {
    margin-top: 12px;
}

.processing {
    opacity: 0.7;
    cursor: not-allowed;
}

.selected {
    background-color: #f0f0f0;
    border-color: #4A90E2;
}

.w-checkbox.selected input[type="checkbox"] {
    border-color: #4A90E2;
}

input:disabled,
button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.email-error {
    border: 2px solid #e53e3e !important;
    background-color: #fff5f5 !important;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-content {
    position: relative;
    background: #fff;
    border-radius: 16px;
    padding: 40px 32px 32px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 16px;
    color: #1a1a1a;
    text-align: center;
}

.modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 4px 8px;
    line-height: 1;
}

.modal-body p {
    font-size: 15px;
    line-height: 1.5;
    color: #555;
    margin: 0 0 24px;
    text-align: center;
}

.modal-btn {
    display: block;
    width: 100%;
    padding: 14px 22px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    margin-bottom: 10px;
}

.modal-btn-primary {
    background: #42cad1;
    color: #fff;
}

.modal-btn-secondary {
    background: #fff;
    color: #1a1a1a;
    border: 1px solid #e0e0e0;
    font-weight: 500;
}
</style>

<script>
import state from "@/utils/state.json"
import { BLOCKED_STATE_MESSAGE, isBlockedState } from "@/utils/blockedStates"
import { checkEmail } from "@/utils/checkEmail"
import { cleanUsPhone, cleanAreaCodeBox, isValidUsPhone } from "@/utils/phone"
import { FREE_NAD_CLAIM_PATH, linkNad } from "@/utils/freeNadLink"
import { syncFreeNadOffer } from "@/utils/freeNadLife"
import {
    mapActions
} from 'vuex'
export default {
    name: 'WeightLossForm2',
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            active_el: 1,
            tempvalue: '',
            formErrors: {},
            shakeConsent: false,
            isSubmitting: false,
            checkingEmail: false,
            emailCheckError: false,
            showPaidUserModal: false,
            modalMode: 'paid',
            modalRole: '',
            // The NAD+ the landing link names, read once on the first load so a later
            // change to the address bar cannot drop the claim button.
            landingNad: linkNad(this.$route.query),

            people: {
                form_type: "home_page_form",
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_parts: {
                    areaCode: '',
                    prefix: '',
                    line: ''
                },
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: false,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                age: '',
                tracking_session_id:'',
                user_agent:'',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
            }
        }
    },
    async mounted() {
        // The free NAD+ offer link (?offer=&nad=) rides to the payment page in the tab's
        // storage, because the funnel drops the query on the way.
        syncFreeNadOffer(this.$route.query);
        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
    },
    computed: {
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        isValidPhone() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            // Check if all parts exist and are the correct length
            return (
                areaCode?.length === 3 &&
                prefix?.length === 3 &&
                line?.length === 4 &&
                /^\d+$/.test(areaCode) &&
                /^\d+$/.test(prefix) &&
                /^\d+$/.test(line)
            );
        },
        phoneNumber() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            if (!this.isValidPhone) return '';
            // Final safety net: never store a leading country-code "1"
            return cleanUsPhone(`${areaCode}${prefix}${line}`);
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },
        // A returning paid patient on a free NAD+ link (?nad=nasal|injection), never a staff account.
        showNadClaim() {
            return this.modalMode === 'paid' && this.landingNad !== '';
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility'
        ]),
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        numericOnly(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },
        autoAdvanceDobField(field, maxLength, nextRef) {
            if (this.people.dob[field].length >= maxLength && this.$refs[nextRef]) {
                this.$refs[nextRef].focus();
            }
        },
        autoAdvanceGeneric(event, maxLength, nextRef) {
            if (event.target.value.length >= maxLength && this.$refs[nextRef]) {
                this.$refs[nextRef].focus();
            }
        },
        validateInches() {
            if (this.people.height.inches) {
                let cleaned = String(this.people.height.inches).replace(/\D/g, '');
                if (cleaned.length > 0) {
                    let numValue = parseInt(cleaned, 10);
                    if (numValue > 11) {
                        cleaned = '11';
                    }
                }
                if (cleaned !== String(this.people.height.inches)) {
                    this.people.height.inches = cleaned;
                }
            }
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            // Check if the date is valid
            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            // Ensure the year is between 1924 and the current year
            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            // Ensure the date is not in the future
            if (date > today) {
                return false;
            }

            return true;
        },
        validateDOB() {
            this.formErrors = {};
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob

            if (!mm || !dd || !yyyy) {
                this.formErrors.dob = 'Please enter a complete date of birth';
                return;
            }

            // Add padding to month and day
            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');

            if (!this.isValidDate(paddedMonth, paddedDay, yyyy)) {
                this.formErrors.dob = 'Please enter a valid date of birth';
                return;
            }

            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`;
            try {
                if (window.tracking) {
                    window.tracking.event('dob_added', { funnel_step: 3, form: 'home' });
                }
            } catch (error) {
                console.log(error);
            }
            this.active_el++;
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches)
            const weightInPounds = parseInt(this.people.weight)
            this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.heightInInches = heightInInches;

        },
async validateStep1() {
            this.formErrors = {};
            if (!this.people.agreed_to_terms) {
                this.formErrors.terms = 'Please agree to the terms and conditions';
                return false;
            }
            try {
                if (window.tracking) {
                    await window.tracking.assertSession();
                    window.tracking.event('questionnaire_start', { funnel_step: 1, form: 'home' });
                }
            } catch (error) {
                console.log(error)
            }
            return true;
        },
        async validateStep2() {
            this.formErrors = {};

            if (!this.people.state) {
                this.$set(this.formErrors, 'state', 'Please select your state');
                return false;
            }

            if (!this.people.first_name || !this.people.last_name) {
                this.$set(this.formErrors, 'name', 'Please enter your full name');
                return false;
            }

            if (!this.people.gender) {
                this.$set(this.formErrors, 'gender', 'Please select your gender');
                return false;
            }

            if (!this.isValidEmail) {
                this.$set(this.formErrors, 'email', 'Please enter a valid email address');
                return false;
            }

            if (!this.people.agreed_to_email) {
                this.$set(this.formErrors, 'emailConsent', 'Please check the consent box to continue');
                this.shakeConsent = true;
                return false;
            }

            const rawPhone = `${this.people.phone_parts.areaCode || ''}${this.people.phone_parts.prefix || ''}${this.people.phone_parts.line || ''}`;
            if (!isValidUsPhone(rawPhone)) {
                this.$set(this.formErrors, 'phone', 'Please enter a complete, valid phone number');
                return false;
            }

            // Check email against existing accounts
            this.checkingEmail = true;
            try {
                const emailResult = await checkEmail(this.people.email);
                if (!emailResult.proceed) {
                    if (emailResult.reason === 'wrong_role') {
                        this.modalMode = 'wrong_role';
                        this.modalRole = emailResult.role;
                        this.showPaidUserModal = true;
                        return false;
                    }
                    if (emailResult.reason === 'paid_user') {
                        this.modalMode = 'paid';
                        this.showPaidUserModal = true;
                        return false;
                    }
                }
            } finally {
                this.checkingEmail = false;
            }

            try {
                if (window.tracking) {
                    window.tracking.event('state', { funnel_step: 2, form: 'home' });
                    window.tracking.event('name_added', { funnel_step: 2, form: 'home' });
                    window.tracking.event('sex_at_birth', { funnel_step: 2, form: 'home' });
                    window.tracking.event('email_complete', { funnel_step: 2, form: 'home' });
                    window.tracking.event('phone_added', { funnel_step: 2, form: 'home' });

                    const partialEventId = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
                    window.tracking.event('partial', { funnel_step: 2, form: 'home', event_id: partialEventId });
                    // Persist form + event_id so /payment/thanks can reuse same event_id on purchase
                    try {
                        localStorage.setItem('tracking_checkout', JSON.stringify({
                            form: 'home',
                            event_id: partialEventId,
                        }));
                    } catch (e) { console.log('tracking_checkout write failed', e); }
                }
            } catch (error) {
                console.log(error)
            }

            return true;
        },
        validateStep3() {
            this.formErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.formErrors.height = 'Please enter a valid height';
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }

            // Calculate height in inches
            this.people.heightInInches = (foot * 12) + inches;
            // Calculate BMI
            this.people.bmi = this.calculatedBMI;
            try {
                if (window.tracking) {
                    window.tracking.event('height', { funnel_step: 4, form: 'home' });
                    window.tracking.event('current_weight', { funnel_step: 4, form: 'home' });
                    window.tracking.event('bmi_confirmation', { funnel_step: 4, form: 'home' });
                }
            } catch (error) {
                console.log(error)
            }

            return true;
        },

        validateStep4() {
            this.formErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.formErrors.desiredWeight = 'Please enter a valid desired weight';
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.formErrors.desiredWeight = 'Desired weight should be less than current weight';
                return false;
            }

            try {
                if (window.tracking) {
                    window.tracking.event('desired_weight', { funnel_step: 5, form: 'home' });
                }
            } catch (error) {
                console.log(error)
            }

            return true;
        },

        async handleSubmit() {
            // The state list no longer offers LA or MS; this still stops a saved or autofilled one.
            if (isBlockedState(this.people.state)) {
                this.$router.push({
                    name: 'leadDisqualified',
                    query: { message: BLOCKED_STATE_MESSAGE }
                });
                return false;
            }
            this.formErrors = {};
            let isValid = false;

            switch (this.active_el) {
                case 1:
                    isValid = await this.validateStep1();
                    break;
                case 2:
                    isValid = await this.validateStep2();
                    break;
                case 3:
                    isValid = true;
                    break;
                case 4:
                    isValid = this.validateStep3();
                    break;
                case 5:
                    isValid = this.validateStep4();
                    break;
            }

            if (!isValid) {
                return;
            }

            if (this.active_el < 5) {
                this.active_el++;
                return;
            }

            // Final submission
            this.finalSubmit();

        },
        async finalSubmit() {
            try {
                if (this.people.dob.yyyy > 2006) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years. "
                        }
                    });
                    return false;
                }
                this.isSubmitting = true;
                this.people.phone = this.phoneNumber;
                this.people.user_agent = window.navigator.userAgent;
                try{
                    this.people.tracking_session_id = await window.tracking.assertSession();
                }catch(error){
                    if (window.trackingSessionId) {
                        this.people.tracking_session_id = window.trackingSessionId;
                    }
                }
                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                if (response.data.status === 'success') {


                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'reportPage',
                        query: {
                            'desiredWeight': this.people.desired_weight
                        }
                    });
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            } finally {
                this.isSubmitting = false;
            }

        },
        goBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },

        handlePhoneInput(event, field) {
            let value = event.target.value.replace(/\D/g, '');
            // A US area code never starts with 1, so a leading 1 here is the country
            // code. Let a lone "1" stay visible, then drop it on the next digit — the
            // same rule the profile and verify screens use. Without this the box shows
            // "155" for a customer who dialled out of habit.
            if (field === 'areaCode') {
                value = cleanAreaCodeBox(value);
            }

            if (value.length == 10) {
                const areaCodeLength = 3;
                const prefixLength = 3;
                const lineLength = 4;

                // Extract each part of the phone number based on its defined length
                this.people.phone_parts.areaCode = value.slice(0, areaCodeLength);
                this.people.phone_parts.prefix = value.slice(areaCodeLength, areaCodeLength + prefixLength);
                this.people.phone_parts.line = value.slice(areaCodeLength + prefixLength, areaCodeLength + prefixLength + lineLength);

            }
            const maxLength = {
                areaCode: 3,
                prefix: 3,
                line: 4
            } [field];

            this.people.phone_parts[field] = value.slice(0, maxLength);

            // Auto-focus next field
            if (value.length >= maxLength) {
                const nextField = {
                    areaCode: 'prefix',
                    prefix: 'line'
                } [field];

                if (nextField) {
                    this.$refs[nextField]?.focus();
                }
            }

        },

        handleGenderSelection(gender) {
            this.people.gender = gender;
        },
        goToLogin() {
            this.showPaidUserModal = false;
            this.$router.push({ path: '/login', query: { email: this.people.email } });
        },
        goToNadClaim() {
            this.showPaidUserModal = false;
            this.$router.push(FREE_NAD_CLAIM_PATH);
        },
        async checkEmailOnBlur() {
            this.emailCheckError = false;
            this.formErrors.email = '';
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.people.email)) return;

            const result = await checkEmail(this.people.email);
            if (!result.proceed) {
                this.emailCheckError = true;
                if (result.reason === 'wrong_role') {
                    this.formErrors.email = `This email is associated with a ${result.role} account. Please use a different email.`;
                    this.modalMode = 'wrong_role';
                    this.modalRole = result.role;
                    this.showPaidUserModal = true;
                } else if (result.reason === 'paid_user') {
                    this.formErrors.email = 'This email already has an account.';
                    this.modalMode = 'paid';
                    this.showPaidUserModal = true;
                }
            }
        }
    },
    watch: {
        calculatedBMI(newBMI) {
            this.people.bmi = newBMI;
        },
        active_el() {
            window.scrollTo(0, 0)
        },
        'people.agreed_to_email'(newVal) {
            if (newVal && this.formErrors.emailConsent) {
                this.$delete(this.formErrors, 'emailConsent');
            }
        }
    }
}
</script>
<style>
@media screen and (max-width: 479px) {
    .enroll-form-header-text-2 {
        width: 80%;
        font-size: 43px;
        line-height: 46px;
        padding-top: 24px;
    }

    .form-question-text.smaller.a {
        width: 100%;
        font-size: 28px;
        line-height: 32px;
    }
}
</style>